import * as React from "react";
const SvgVideoPlus = (props) => /* @__PURE__ */ React.createElement(
  "svg",
  {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...props
  },
  /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M7.91667 7.5V12.5M5.41667 10H10.4167M13.3333 8.33333L15.4807 7.04493C16.1416 6.64836 16.4721 6.45008 16.744 6.47542C16.9811 6.49752 17.1974 6.62 17.3384 6.81194C17.5 7.03207 17.5 7.41746 17.5 8.18825V11.8117C17.5 12.5825 17.5 12.9679 17.3384 13.1881C17.1974 13.38 16.9811 13.5025 16.744 13.5246C16.4721 13.5499 16.1416 13.3516 15.4807 12.9551L13.3333 11.6667M5.16667 15H10.6667C11.6001 15 12.0668 15 12.4233 14.8183C12.7369 14.6586 12.9919 14.4036 13.1517 14.09C13.3333 13.7335 13.3333 13.2668 13.3333 12.3333V7C13.3333 6.29993 13.3333 5.9499 13.1971 5.68251C13.0772 5.44731 12.886 5.25608 12.6508 5.13624C12.3834 5 12.0334 5 11.3333 5H4.5C3.79993 5 3.4499 5 3.18251 5.13624C2.94731 5.25608 2.75608 5.44731 2.63624 5.68251C2.5 5.9499 2.5 6.29993 2.5 7V12.3333C2.5 13.2668 2.5 13.7335 2.68166 14.09C2.84144 14.4036 3.09641 14.6586 3.41002 14.8183C3.76654 15 4.23325 15 5.16667 15Z",
      stroke: "currentColor",
      strokeWidth: 1.5,
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  )
);
export default SvgVideoPlus;
